// solvedDeliveryService.js
// Servicio aislado para sincronizar el estado de entrega de una factura con SOLVED.
// Nunca lanza: siempre devuelve un resultado normalizado { success, message, raw? }
// para que un fallo externo no rompa el flujo principal de la aplicación.
import axios from "axios";

// Fallbacks por si faltan las env (robustez ante problemas de configuración)
const DELIVERY_STATUS_URL =
  process.env.REACT_APP_SOLVED_API_DELIVERY_STATUS_REAL ||
  "https://www.solved1.com/api/etcexpress/v1/changedata/deliverystatus/";
const APIKEY =
  process.env.REACT_APP_SOLVED_APIKEY || "41ypvRfe4qG0qF6Ge96ENEDSTJUzar";
const ENTERPRISE = process.env.REACT_APP_SOLVED_ENTERPRISE || "etcexpress";

/**
 * Cambia el estado de entrega de una factura en el sistema externo SOLVED.
 *
 * @param {string} code - Código de la factura en nuestro sistema (se envía como `hbl`).
 * @param {string} [status="ENTREGADO"] - Estado destino a reportar a SOLVED.
 * @returns {Promise<{success: boolean, message: string, raw?: any}>} Resultado normalizado.
 *
 * @example
 * const res = await updateDeliveryStatusSolved("ETC00002");
 * if (!res.success) console.warn(res.message);
 */
export async function updateDeliveryStatusSolved(code, status = "ENTREGADO") {
  if (!code) return { success: false, message: "Código de factura ausente" };

  const data = { enterprise: ENTERPRISE, number: [{ hbl: code, status }] };

  try {
    const response = await axios.get(DELIVERY_STATUS_URL, {
      params: { apikey: APIKEY, data: JSON.stringify(data) },
      timeout: 15000, // evita que el spinner cuelgue indefinidamente
    });

    const body = response?.data;

    // Interpretación defensiva: 2xx = éxito salvo que el cuerpo indique error explícito
    if (body && (body.success === false || body.error)) {
      return {
        success: false,
        message: body.error || body.message || "SOLVED rechazó la operación",
        raw: body,
      };
    }

    return {
      success: true,
      message: (body && body.message) || "Sincronizado con SOLVED",
      raw: body,
    };
  } catch (error) {
    console.error("[SOLVED deliverystatus] error:", error);
    const message = error?.response
      ? `SOLVED respondió ${error.response.status}`
      : error?.code === "ECONNABORTED"
      ? "Tiempo de espera agotado con SOLVED"
      : "No se pudo conectar con SOLVED";
    return { success: false, message };
  }
}
